$bog_music_qrscan $mol_view
	scanning? false
	prefix \
	found? \
	sub /
		<= Toggle $mol_check
			title @ \Сканировать QR
			checked? <=> scanning?
		<= Camera $mol_video_camera
			facing \environment
			muted true
